<template>
  <VersionManagement :isTestPortal="true" />
</template>
<script>
import VersionManagement from "./version-management.vue";

export default {
  name: "test-portal-version-management",
  components: {
    VersionManagement
  }
};
</script>
